











































































































































import Vue from 'vue';
import _ from 'lodash';
import TextHighlight from 'vue-text-highlight';

import Requester from '../../requester';

import { Usuario } from '../../../../back/src/entity/Usuario';
import { Grupo } from '../../../../back/src/entity/Grupo';

import Carregando from '../../components/Carregando.vue';
import CustomDialog from '../../components/CustomDialog.vue';
import TheUsuariosDetalhes from '../../components/usuarios/TheUsuariosDetalhes.vue';
import TheUsuariosEdit from '../../components/usuarios/TheUsuariosEdit.vue';

export default Vue.extend({
  name: 'UsuariosIndex',
  components: {
    Carregando,
    CustomDialog,
    TheUsuariosDetalhes,
    TheUsuariosEdit,
    TextHighlight,
  },
  data() {
    return {
      loading: {
        usuarios: true,
        grupos: true,
      },
      usuarios: [] as Usuario[],
      usuarioSelecionado: {} as Usuario,
      grupos: [] as Grupo[],
      colors: [
        'red', 'pink', 'purple',
        'deep-purple', 'indigo', 'blue',
        'light-blue', 'cyan', 'teal',
        'green', 'light-green', 'lime',
        'yellow', 'amber', 'orange',
        'deep-orange', 'brown', 'blue-grey',
        'grey',
      ],
      search: '',
      dialogDetalhes: false,
      editUsuario: false,
    };
  },
  computed: {
    headers() {
      if (this.$vuetify.breakpoint.xsOnly) {
        return [
          {
            value: 'nome',
            text: 'Nome ',
            sortable: true,
          },
          {
            value: 'grupo.nome',
            text: 'Grupo ',
            sortable: true,
          },
        ];
      }
      return [
        {
          value: 'nome',
          text: 'Nome ',
          sortable: true,
        },
        {
          value: 'email',
          text: 'Email ',
          sortable: true,
        },
        {
          value: 'grupo.nome',
          text: 'Grupo ',
          sortable: true,
        },
        {
          value: 'ativo',
          text: 'Ativo ',
          sortable: true,
        },
        {
          value: 'actions',
          text: 'Ações',
          sortable: false,
          width: 0,
          align: 'center',
        },
      ];
    },
    modalVerUsuario(): Vue & { open: () => void } {
      return this.$refs.modalVerUsuario as Vue & { open: () => void };
    },
  },
  mounted() {
    this.getUsuarios();
    this.getGrupos();
  },
  methods: {
    avatarColor(id: number): string {
      return this.colors[id % this.colors.length];
    },
    clickRow(usuario: Usuario) {
      this.usuarioSelecionado = usuario;
      this.dialogDetalhes = true;
    },
    atualizaUsuario(usuario: Usuario) {
      this.editUsuario = false;
      const index = _.findIndex(
        this.usuarios as Usuario[],
        el => (el.id === usuario.id),
      );
      if (index >= 0) {
        this.$set(this.usuarios, index, usuario);
      }
      if (usuario.id === this.usuarioSelecionado.id) {
        this.usuarioSelecionado = usuario;
      }
    },
    async getUsuarios(): Promise<void> {
      this.loading.usuarios = true;
      try {
        const response = await Requester.usuario.usuarios();
        if (response.errors.length > 0) {
          this.$root.$emit('avisoSnackbar', { color: 'error', text: response.errors });
        } else {
          this.usuarios = response.data;
        }
      } catch (err) {
        this.$root.$emit('requestError', err);
      } finally {
        this.loading.usuarios = false;
      }
    },
    async getGrupos(): Promise<void> {
      this.loading.grupos = true;
      try {
        const response = await Requester.grupo.grupos();
        if (response.errors.length > 0) {
          this.$root.$emit('avisoSnackbar', { color: 'error', text: response.errors });
        } else {
          this.grupos = response.data;
        }
      } catch (err) {
        this.$root.$emit('requestError', err);
      } finally {
        this.loading.grupos = false;
      }
    },
  },
});
